export const authKeys = {
  login: "/public/auth/login",
  otpVerify: "/public/register/verify-code",
  restore: "/public/auth/restore",
  register: "/public/register",
  promo: "/public/promo",
  // TODO: other keys
  logout: "/public/auth/logout",
  refresh: "/public/auth/refresh",
  forgotPassword: "/public/auth/forgot-password",
  resetPassword: "/public/auth/reset-password",
  verifyEmail: "/public/auth/verify-email",
  resendEmailVerification: "/public/auth/resend-email-verification",
};
